<template>
  <div class="text-neutral-800 toast-modal-button o-body text-center mt-6 px-4 pb-10 lg:px-9">
    <button
      class="flex text-center w-full items-center justify-center"
      :class="classes.button"
      :disabled="disabled"
      type="button"
      @click="$emit('click')"
    >
      <span v-text="text ? text : $t('Account.Home.General.Close')" />
      <OSvg class="w-3 fill-current pl-1" svg="new-chevron-right" />
    </button>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'ToastModalFooter',
  components: { OSvg },
  props: {
    variant: {
      type: String,
      default: 'plane',
      validator: value => ['solid', 'outline', 'plane'].includes(value)
    },
    color: {
      type: String,
      default: 'blue',
      validator: value => ['blue', 'black', 'yellow', 'dark-green'].includes(value)
    },
    text: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        button: `toast-modal-button-${this.variant} toast-modal-button-${this.color}`
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.toast-modal-button {
  svg {
    padding-top: .2rem;
  }

  button {
    @apply px-5 py-2;
    border-radius: 10rem;
  }

  &-outline {
    @apply border border-newBlue-400 text-newBlue-400;

    &.toast-modal-button-black {
      @apply text-neutral-800 border-neutral-800;
    }
  }

  &-solid {
    &.toast-modal-button-yellow {
      @apply bg-yellow-400 text-neutral-800 font-bold;

      &:hover {
        @apply bg-yellow-600;
      }
    }

    &.toast-modal-button-dark-green {
      @apply text-white border-green-400 bg-green-400 border-1;

      &:focus {
        outline: none;
      }

      &:hover {
        @apply bg-green-500;
      }
    }
  }
}
</style>
